// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/element_ui.js';
import App from './App'
import router from './router'
import './style/acce.css';
import '@/permission' // permission control

Vue.config.productionTip = false
if(window.screen.width<500){
	window.location.href='http://m.kwsk-cq.com'
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js